import type { Component } from "solid-js";
import { appEnv, isProduction } from "@config/env";

export const FooterStatusBar: Component = () => {
  return (
    <footer class="app-footer">
      <div class="footer-left">
        <div style="display:flex;align-items:center;gap:6px;">
          <span class="status-dot" aria-hidden />
          <span>{isProduction ? "Production" : "Preview"}</span>
        </div>
        <span>Project: {appEnv.firebase.projectId}</span>
        <span>Region: {appEnv.firebase.region}</span>
      </div>
      <div class="footer-right">
        <span>HappyTidy Backoffice</span>
      </div>
    </footer>
  );
};
